'use strict';

const Backbone = require('backbone');

require('./tip_submitter');

class TipsFrontendBuilder {
  static build(
    csrfToken,
    placeId,
    tipCount,
    offset,
    maxTipLength,
    minTipLength,
    hasPreviousTip,
    isTouch
  ) {
    const tipEvents = window._.extend({}, Backbone.Events);

    const UserTipOwnershipModel = Backbone.Model.extend();
    const userTipOwnershipModel = new UserTipOwnershipModel({
      userHasTips: hasPreviousTip,
    });

    new Groupon.Tips({
      el: '.tips-module',
      csrf: csrfToken,
      offset,
      placeId,
      tipCount,
      maxTipLength,
      minTipLength,
      tipEvents,
      userTipOwnershipModel,
      isTouch,
    });
  }
}

Groupon.TipsFrontendBuilder = TipsFrontendBuilder;

$(window).load(() => {
  const $el = $('.tips-module');

  if (!($el.length > 0)) {
    return;
  }

  const place = $('.mpp-container').data();
  const tipsConfig = $el.data();
  const csrfToken = $('meta[name=csrf-token]').attr('content');

  Groupon.TipsFrontendBuilder.build(
    csrfToken,
    place.placeId,
    tipsConfig.totalTips,
    tipsConfig.offset,
    tipsConfig.maxTipLength,
    tipsConfig.minTipLength,
    tipsConfig.hasPreviousTip,
    tipsConfig.isTouch
  );
});
